// extracted by mini-css-extract-plugin
export var navLinks = "header-module--nav-links--mDou8";
export var mouseIconLink = "header-module--mouse-icon-link--qi5aT";